/**
 * Custom mobile navigation — 11th Hour Coffee
 * Manages drawer open/close, L1/L2 level transitions, focus, and keyboard.
 */
document.addEventListener('DOMContentLoaded', function () {
  (function () {
    'use strict';

    var drawer = document.getElementById('custom-nav-drawer');
    var overlay = document.getElementById('custom-nav-overlay');
    var closeBtn = document.getElementById('custom-nav-close');
    var backBar = document.getElementById('custom-nav-back');
    var backLabel = document.getElementById('custom-nav-back-label');
    var dots = drawer ? drawer.querySelectorAll('.custom-nav-dot') : [];

    if (!drawer || !overlay) return;

    // Mark elements ready so inline <style> allows display
    drawer.classList.add('css-ready');
    overlay.classList.add('css-ready');

    var currentLevel = 1;
    var activeL2 = null;
    var triggerElement = null;
    var sectionHeader = document.querySelector('.section-header');

    // Find Trade's existing hamburger summary button
    var hamburgerSummary = document.querySelector(
      'header-drawer > details > summary.header__icon--menu'
    );

    if (!hamburgerSummary) return;

    // ── Intercept Trade's hamburger ──
    // Capture phase so we fire before Trade's MenuDrawer.onSummaryClick
    hamburgerSummary.addEventListener(
      'click',
      function (e) {
        if (window.innerWidth >= 990) return; // Let desktop behavior through

        e.preventDefault();
        e.stopImmediatePropagation();

        // Ensure Trade's details doesn't open
        var details = hamburgerSummary.closest('details');
        if (details && details.hasAttribute('open')) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        }

        openDrawer();
      },
      true
    );

    // ── Open drawer ──
    function openDrawer() {
      triggerElement = document.activeElement;
      drawer.classList.add('custom-nav-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('custom-nav-overlay--visible');
      overlay.setAttribute('aria-hidden', 'false');
      hamburgerSummary.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      // Reset to L1
      resetToL1(true);

      // Focus close button
      setTimeout(function () {
        closeBtn.focus();
      }, 50);
    }

    // ── Close drawer ──
    function closeDrawer() {
      drawer.classList.remove('custom-nav-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('custom-nav-overlay--visible');
      overlay.setAttribute('aria-hidden', 'true');
      hamburgerSummary.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      // Return focus to hamburger
      if (triggerElement) {
        triggerElement.focus();
        triggerElement = null;
      }
    }

    // ── Close button ──
    closeBtn.addEventListener('click', closeDrawer);

    // ── Overlay click ──
    overlay.addEventListener('click', closeDrawer);

    // ── Escape key ──
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer.getAttribute('aria-hidden') === 'true') return;

      e.preventDefault();
      if (currentLevel === 2) {
        goBack();
      } else {
        closeDrawer();
      }
    });

    // ── L1 parent row clicks ──
    var parentRows = drawer.querySelectorAll('.custom-nav-row--parent[data-target]');
    parentRows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        e.preventDefault();
        var target = row.getAttribute('data-target');
        navigateToL2(target);
      });
    });

    // ── Navigate to L2 ──
    function navigateToL2(panelId) {
      var l1 = drawer.querySelector('[data-level="l1"]');
      var l2 = drawer.querySelector('[data-level="' + panelId + '"]');
      if (!l1 || !l2) return;

      currentLevel = 2;
      activeL2 = panelId;

      // Animate L1 out left
      l1.classList.remove('custom-nav-level--active');
      l1.classList.add('custom-nav-level--exit');

      // Animate L2 in from right
      l2.classList.remove('custom-nav-level--right', 'custom-nav-level--exit');
      l2.classList.add('custom-nav-level--active');

      // Update dots
      updateDots(2);

      // Show back bar
      var parentLabel = l2.getAttribute('data-parent-label') || '';
      backLabel.textContent = parentLabel;
      backBar.classList.add('custom-nav-back--visible');

      // Focus first nav row in L2
      setTimeout(function () {
        var firstRow = l2.querySelector('.custom-nav-row');
        if (firstRow) firstRow.focus();
      }, 100);
    }

    // ── Back bar ──
    backBar.addEventListener('click', goBack);
    backBar.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        goBack();
      }
    });

    function goBack() {
      if (currentLevel !== 2 || !activeL2) return;

      var l1 = drawer.querySelector('[data-level="l1"]');
      var l2 = drawer.querySelector('[data-level="' + activeL2 + '"]');
      if (!l1 || !l2) return;

      currentLevel = 1;

      // Animate L2 out right
      l2.classList.remove('custom-nav-level--active', 'custom-nav-level--exit');
      l2.classList.add('custom-nav-level--right');

      // Animate L1 back in
      l1.classList.remove('custom-nav-level--exit', 'custom-nav-level--right');
      l1.classList.add('custom-nav-level--active');

      // Update dots
      updateDots(1);

      // Hide back bar
      backBar.classList.remove('custom-nav-back--visible');

      // Focus the parent row that opened this L2
      setTimeout(function () {
        var parentRow = drawer.querySelector('[data-target="' + activeL2 + '"]');
        if (parentRow) parentRow.focus();
        activeL2 = null;
      }, 100);
    }

    // ── Reset to L1 (instant, no animation) ──
    function resetToL1(instant) {
      currentLevel = 1;
      activeL2 = null;

      var allLevels = drawer.querySelectorAll('.custom-nav-level');
      allLevels.forEach(function (level) {
        level.classList.remove(
          'custom-nav-level--active',
          'custom-nav-level--exit',
          'custom-nav-level--right'
        );
        if (level.getAttribute('data-level') === 'l1') {
          level.classList.add('custom-nav-level--active');
        }
      });

      updateDots(1);
      backBar.classList.remove('custom-nav-back--visible');
    }

    // ── Update level dots ──
    function updateDots(level) {
      dots.forEach(function (dot) {
        var dotLevel = parseInt(dot.getAttribute('data-dot'), 10);
        if (dotLevel <= level) {
          dot.classList.add('custom-nav-dot--active');
        } else {
          dot.classList.remove('custom-nav-dot--active');
        }
      });
    }

    // ── Focus trap ──
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (drawer.getAttribute('aria-hidden') === 'true') return;

      var focusable = drawer.querySelectorAll(
        'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), [tabindex="0"]'
      );
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  })();
});
